export const truncate = (str, length = 54) => {
    if (str === undefined) return '';
    return str.length > length ? `${str.substring(0, length)}...` : str;
}